import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "q-pa-md" }
const _hoisted_2 = { class: "text-h4 text-weight-medium" }
const _hoisted_3 = { class: "row q-gutter-lg" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = { class: "row q-gutter-sm" }
const _hoisted_6 = { class: "row q-py-md" }
const _hoisted_7 = { class: "col" }

import { computed, inject, ref } from 'vue'
import PreviousActivityItem from '../components/PreviousActivityItem.vue'
import { useQuasar } from 'quasar'
import { useCurrentCycle } from '../store/useCurrentCycle'
import { useTimesheets } from '../store/timesheets'
import { storeToRefs } from 'pinia'
import { usePayrollWindow } from '../store/usePayrollWindow'
import { useFormatDate } from '../composables/formatDate'
import PreviousActivitiesScorecardsAll from '../components/PreviousActivitiesScorecardsAll.vue'
import { useI18n } from 'vue-i18n'
import { useUserStore } from '../store/useUserStore'
import { onBeforeRouteLeave } from 'vue-router'
import { isNullish } from '../utils'
//for ripple

export default /*#__PURE__*/_defineComponent({
  __name: 'PagePreviousTimesheets',
  setup(__props, { expose: __expose }) {

const $q = useQuasar()
__expose({ $q })

//translations
const { t } = useI18n({ useScope: 'global' })
const label = (key: string) => t(`payPeriod.${key}`)

//timeline items
const { getTimesheets } = storeToRefs(useTimesheets())
const timesheetItems = ref(getTimesheets)

//cycle
const { getCycle } = storeToRefs(useCurrentCycle())
//payroll window text
const payroll = storeToRefs(usePayrollWindow())
const store = storeToRefs(useUserStore())

const payrollWindowText = computed(() => {
  if (payroll.current.value) {
    const start = useFormatDate(payroll.current.value.start, { language_choice: store.language })
    const end = useFormatDate(payroll.current.value.end, { language_choice: store.language })
    return `${start.weekday()} ${start.month()} ${start.day()} - ${end.weekday()} ${end.month()} ${end.day()} `
  } else {
    return ''
  }
})
const globalTimesheetInstance = inject('globalTimesheetInstance')

const hasReadyToSync = computed(() => {
  return timesheetItems.value.some((item) => item.readyToSync)
})
onBeforeRouteLeave(async (to, from, next) => {
  // Exhaustive check that the user is not
  // navigating to a previous activity that is not ready to sync
  // This is usually done with the back button.
  if (hasReadyToSync.value) {
    if (to.name != 'previous_activity') {
      return next()
    }
    if (isNullish(to.params.id)) {
      return next()
    }
    const timesheet = timesheetItems.value[Number(to.params.id)]
    if (timesheet && !timesheet.readyToSync) {
      return next()
    }
    return next(false)
  } else {
    return next()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(label('title')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("p", null, _toDisplayString(payrollWindowText.value), 1),
          _createElementVNode("p", null, _toDisplayString(label('cycle')) + " " + _toDisplayString(_unref(getCycle) && _unref(getCycle).cycle_number ? _unref(getCycle).cycle_number : ''), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(PreviousActivitiesScorecardsAll, { timesheets: timesheetItems.value }, null, 8, ["timesheets"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", null, _toDisplayString(label('delayNote')), 1)
        ])
      ])
    ]),
    _createVNode(_component_q_list, null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timesheetItems.value, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: item }, [
            _createVNode(PreviousActivityItem, _mergeProps({
              to: 
          _unref(globalTimesheetInstance) || item.readyToSync ? undefined : `/previous_activities/${index}`
        ,
              "fix-by": _unref(payroll).current.value ? _unref(payroll).current.value.end : undefined
            }, item), null, 16, ["to", "fix-by"]),
            (index < timesheetItems.value.length - 1)
              ? (_openBlock(), _createBlock(_component_q_separator, {
                  key: 0,
                  spaced: "",
                  inset: ""
                }))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ]),
      _: 1
    })
  ], 64))
}
}

})